const { Core, Utils } = Global;
const { $active } = Utils;

const CN_ACTIVE = '!active';

customElements.define('accordion-with-images', class extends Core {
    elements = {
        $: [['thumbnail'], ['image']]
    }

    render() {
        this.$('thumbnail', {
            click: this._handleThumbnailClick
        })
        
        this.activeImage = this.$('image').at(0);
    }

    _handleThumbnailClick(e) {
        // The thumbnail associated with the active image must always be open 
        if (e.currentTarget.hasAttribute('open')) {
            e.preventDefault();
            return;
        }

        this._setActiveImage(e.currentTarget.dataset.thumbIndex);
    }

    _setActiveImage(index) {
        this.activeImage && $active(this.activeImage, false);
        this.activeImage = this.$('image').at(index);
        $active(this.activeImage);
    }
})